import { OrderGroupDetailed } from 'src/reactQuery/orders/interfaces/orderGroup.interface';
import { API_URL_M7, getCachedSessionId } from 'src/services/common';
import { apiM7 } from 'src/util/axios-instance';

export const getOrderGroupById = async (
  projectId: string,
  orderGroupId: string
): Promise<OrderGroupDetailed | undefined> => {
  const response = await apiM7.get(
    `${API_URL_M7}/api_admin/v1/project/${projectId}/ecommerce/order-group/${orderGroupId}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};
